import { api } from './api';
import { ApiResponse, FileUploadResponse, ClinicSetupData, Clinic } from '../types';

class ClinicSetupService {
  /**
   * Upload KTP document
   * @param file - KTP document file (JPG, PNG, or PDF, max 5MB)
   * @param onProgress - Optional callback for upload progress
   * @returns File upload response
   */
  async uploadKTP(file: File, onProgress?: (progress: number) => void): Promise<ApiResponse<FileUploadResponse>> {
    return api.upload<FileUploadResponse>('/clinic-setup/upload-ktp', file, onProgress);
  }

  /**
   * Upload KTA PDHI document
   * @param file - KTA PDHI document file (JPG, PNG, or PDF, max 5MB)
   * @param onProgress - Optional callback for upload progress
   * @returns File upload response
   */
  async uploadKTAPDHI(file: File, onProgress?: (progress: number) => void): Promise<ApiResponse<FileUploadResponse>> {
    return api.upload<FileUploadResponse>('/clinic-setup/upload-kta-pdhi', file, onProgress);
  }

  /**
   * Complete clinic setup
   * @param data - Clinic setup data
   * @returns Clinic data
   */
  async setupClinic(data: ClinicSetupData): Promise<ApiResponse<Clinic>> {
    const response = await api.post<Clinic>('/clinic-setup', data);

    // Update user's onboarding status if clinic setup is successful
    if (response.success) {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          const user = JSON.parse(storedUser);
          user.hasCompletedOnboarding = true;
          localStorage.setItem('user', JSON.stringify(user));
        } catch (error) {
          console.error('Failed to update user onboarding status:', error);
        }
      }
    }

    return response;
  }
}

export const clinicSetupService = new ClinicSetupService();
